import React from 'react'
import PropTypes from 'prop-types'
import * as Component from '../Cluster.styles'
import { parseHighlightedString } from 'settings/app/helpers'

const Match = ({ match, matchClicked, matchNumber }) => (
  <Component.Match
    onClick={ () => matchClicked(match.source) }
    tabIndex='0'
    onKeyDown={ (e) => (e.key === 'Enter' ? matchClicked(match.source) : null) }>
    <span>{parseHighlightedString(match.highlight, matchNumber)}</span>
  </Component.Match>
)

Match.propTypes = {
  match: PropTypes.shape({
    source: PropTypes.shape({
      name: PropTypes.string.isRequired,
      zip_code: PropTypes.string.isRequired,
    }).isRequired,
    highlight: PropTypes.string.isRequired,
  }),
  /**
   * handler for selection
   * * Signature: function(match: string) {...}
   */
  matchClicked: PropTypes.func.isRequired,
  /** match number for cypress testing **/
  matchNumber: PropTypes.number.isRequired,
}

export default Match
